/* Caipi Redesign — Algolia InstantSearch (/search) hit template → rd-tile card.
   Renders search hits with the same redesign product card as the category page
   (image, brand, badges, "Jetzt säen", price + quick-add "+"), so /search looks
   1:1 like the PLP. Uses the documented Algolia Shopify hook API:
   register inside the "algolia.hooks.initialize" event; the *Template hook MUST
   return a tagged template literal (html``).  No-op without the Algolia app. */
(function () {
  "use strict";

  function moneyDE(p) { var n = Number(p); if (isNaN(n)) return ""; return n.toFixed(2).replace(".", ",") + " €"; }
  function bigImg(u) { if (!u) return ""; try { return String(u).replace(/_(\d+x\d*)\.(jpe?g|png|webp|gif)/i, "_600x.$2"); } catch (e) { return u; } }
  // Kollektions-Bild (kein _NNNx-Muster) → kleines Thumbnail via Shopify-CDN width-Param.
  function collImg(u) { if (!u) return ""; try { var s = String(u); return s + (s.indexOf("?") > -1 ? "&" : "?") + "width=160"; } catch (e) { return u; } }
  function tagHit(tags, t) { if (!Array.isArray(tags)) return false; t = t.toLowerCase(); for (var i = 0; i < tags.length; i++) { if (String(tags[i]).toLowerCase() === t) return true; } return false; }
  // Vorbestellung über Kalenderwochen-Tag (plain „KW<Zahl>" = geplante Versandwoche).
  // Schließt „KW35_NEBELUNG" o.ä. aus (Lieferanten-Tag) und ändert NICHTS an Timesact
  // (backorder/out_of_stock-Tags steuern dort die Selling-Plans und werden nicht angefasst).
  function kwPreorder(tags) { if (!Array.isArray(tags)) return false; for (var i = 0; i < tags.length; i++) { if (/^KW\d+$/i.test(String(tags[i]).trim())) return true; } return false; }

  function renderTile(hit, html, components, track) {
    var tags = hit.tags || hit._tags || [];
    var url = "/products/" + (hit.handle || "");
    var img = bigImg(hit.product_image || hit.image || "");
    var avail = (hit.can_order === true) || (hit.inventory_available === true) || (hit.inventory_policy === "continue");
    var price = moneyDE(hit.price);
    // Reduziert? Streichpreis + Ersparnis (Feld compare_at_price im Index, 0 = nicht reduziert).
    var cmpN = Number(hit.compare_at_price), prN = Number(hit.price);
    var onSale = !isNaN(cmpN) && !isNaN(prN) && cmpN > prN;
    var compareDE = onSale ? moneyDE(hit.compare_at_price) : "";
    var savePct = onSale ? Math.round((cmpN - prN) / cmpN * 100) : 0;
    var badgeLabel = "", badgeClass = "";
    if (tagHit(tags, "bio")) { badgeLabel = "Bio"; badgeClass = "bio"; }
    else if (tagHit(tags, "f1")) { badgeLabel = "F1"; badgeClass = "f1"; }
    else if (tagHit(tags, "neu") || tagHit(tags, "neuheit")) { badgeLabel = "Neu"; badgeClass = "neu"; }
    else if (tagHit(tags, "topseller")) { badgeLabel = "Topseller"; badgeClass = "top"; }
    var jetzt = tagHit(tags, "jetzt-saen");
    // Lager-/Saison-Status (aus dem Such-Design): Auf Lager / Vorbestellung / Ausverkauft.
    var statusKey, statusLabel;
    if (hit.inventory_available === true) { statusKey = "lager"; statusLabel = "Auf Lager"; }
    else if (hit.can_order === true || hit.inventory_policy === "continue") { statusKey = "preorder"; statusLabel = "Vorbestellung"; }
    else { statusKey = "out"; statusLabel = "Ausverkauft"; }
    // Vorbestellung → Status überschreiben (Algolia meldet bei `continue`
    // inventory_available=true → sonst fälschlich „Auf Lager"). Signal: KW-Versandwoche-Tag
    // (KW31/KW35/…) oder vorhandener `backorder`-Tag.
    if (kwPreorder(tags) || tagHit(tags, "backorder")) { statusKey = "preorder"; statusLabel = "Vorbestellung"; }
    var aria = (hit.title || "") + (statusKey === "preorder" ? " vorbestellen" : " in den Warenkorb");
    var bio = tagHit(tags, "bio");
    // Grundpreis nur, wenn der Index die Felder führt (sonst sauber weggelassen).
    var grund = (hit.base_unit_price != null && hit.base_unit_name) ? (moneyDE(hit.base_unit_price) + "/" + hit.base_unit_name) : "";
    var cartIcon = html`<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#243a1a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.7 13.4a2 2 0 0 0 2 1.6h9.7a2 2 0 0 0 2-1.6L23 6H6"></path></svg>`;
    return html`
      <div class=${"rd-tile rd-tile--search rd-tile--" + statusKey}>
        <div class="rd-tile__imgwrap">
          <a href=${url} class="rd-tile__imglink" aria-label=${hit.title || ""}>
            ${img ? html`<img class="rd-tile__img" src=${img} alt=${hit.title || ""} loading="lazy" />` : ""}
          </a>
          ${badgeLabel ? html`<span class=${"rd-tile__badge rd-tile__badge--" + badgeClass}>${badgeLabel}</span>` : ""}
          ${jetzt ? html`<span class="rd-tile__jetzt">Jetzt säen</span>` : ""}
          ${(onSale || statusKey === "preorder") ? html`<div class="rd-tile__flags">
            ${statusKey === "preorder" ? html`<span class="rd-tile__flag rd-tile__flag--preorder">Vorbestellung</span>` : ""}
            ${onSale ? html`<span class="rd-tile__sale">−${savePct} %</span>` : ""}
          </div>` : ""}
        </div>
        <a href=${url} class="rd-tile__textlink">
          <div class="rd-tile__chips">
            ${hit.vendor ? html`<span class="rd-tile__chip rd-tile__chip--brand">${hit.vendor}</span>` : ""}
            ${bio ? html`<span class="rd-tile__chip rd-tile__chip--bio">Bio</span>` : ""}
          </div>
          <p class="rd-tile__name">${components.Highlight({ attribute: "title", hit: hit })}</p>
          <span class=${"rd-tile__status rd-tile__status--" + statusKey}><span class="rd-tile__statusdot" aria-hidden="true"></span>${statusLabel}</span>
          <div class="rd-tile__pricerow">
            <span class=${"rd-tile__price" + (onSale ? " rd-tile__price--sale" : "")}>${price}</span>
            ${onSale ? html`<s class="rd-tile__compare">${compareDE}</s>` : ""}
            ${grund ? html`<span class="rd-tile__grund">${grund}</span>` : ""}
          </div>
        </a>
        ${avail
          ? html`<button type="button" class="rd-tile__atc rd-qa-search" data-vid=${String(hit.objectID)} aria-label=${aria} onClick=${function () { try { if (typeof track === "function") track(hit); } catch (e) {} }}>${cartIcon}<span>${statusKey === "preorder" ? "Vorbestellung" : "In den Korb"}</span></button>`
          : html`<a href=${url} class="rd-tile__atc rd-tile__atc--ghost">Benachrichtigen</a>`}
      </div>`;
  }

  // Autocomplete-Produkt-Item: identische Struktur wie das App-Default
  // (aa-ItemPicture / aa-ItemContentBrand / -Title / -Price) + Verfügbarkeits-
  // Status. Felder wie /search (inventory_available / can_order / inventory_policy).
  function renderAcProduct(p) {
    var item = p.item, html = p.html, components = p.components;
    var url = "/products/" + (item.handle || "") + "/";
    var img = item.product_image || item.image || "";
    var brand = item.product_type || "";
    var vendor = item.vendor || "";
    var statusKey, statusLabel;
    if (item.inventory_available === true) { statusKey = "lager"; statusLabel = "Auf Lager"; }
    else if (item.can_order === true || item.inventory_policy === "continue") { statusKey = "preorder"; statusLabel = "Vorbestellung"; }
    else { statusKey = "out"; statusLabel = "Ausverkauft"; }
    if (kwPreorder(item.tags || item._tags) || tagHit(item.tags || item._tags, "backorder")) { statusKey = "preorder"; statusLabel = "Vorbestellung"; }
    var title;
    try { title = components.Highlight({ hit: item, attribute: "title" }); } catch (e) { title = item.title || ""; }
    var price = (item.price != null && item.price !== "") ? ("€" + Number(item.price).toFixed(2).replace(".", ",")) : "";
    // Reduziert? Streichpreis im Dropdown (Feld compare_at_price, 0 = nicht reduziert).
    var acCmp = Number(item.compare_at_price), acPr = Number(item.price);
    var acSale = !isNaN(acCmp) && !isNaN(acPr) && acCmp > 0 && acCmp > acPr;
    var compareAc = acSale ? ("€" + acCmp.toFixed(2).replace(".", ",")) : "";
    var showStatus = statusKey !== "lager"; // nur Vorbestellung/Ausverkauft hervorheben
    return html`
      <a href=${url} class=${"aa-ItemLink aa-ProductItem rd-aa--" + statusKey}>
        <div class="aa-ItemContent">
          <div class="aa-ItemPicture aa-ItemPicture--loaded">
            ${img ? html`<img src=${img} alt=${item.title || ""} />` : ""}
          </div>
          <div class="aa-ItemContentBody">
            <div class="aa-ItemContentBrand">${brand}${vendor ? html`<span> von </span>${vendor}` : ""}</div>
            <div class="aa-ItemContentTitleWrapper"><div class="aa-ItemContentTitle">${title}</div></div>
            <div class="aa-ItemContentPrice">
              <div class=${"aa-ItemContentPriceCurrent" + (acSale ? " rd-aa-price--sale" : "")}>${price}</div>
              ${acSale ? html`<s class="rd-aa-compare">${compareAc}</s>` : ""}
              ${showStatus ? html`<span class=${"rd-aa-status rd-aa-status--" + statusKey}>${statusLabel}</span>` : ""}
            </div>
          </div>
        </div>
      </a>`;
  }

  function register() {
    try {
      var a = window.algoliaShopify;
      if (!a || !a.hooks || typeof a.hooks.registerHook !== "function" || a.__rdSearchCard) return;
      a.__rdSearchCard = true;
      a.hooks.registerHook("beforeInstantSearchProductTemplate", function (_def, hit, html, components, track) {
        try { return renderTile(hit, html, components, track); }
        catch (e) { return _def; }
      });

      // Autocomplete-Optionen eindeutschen: im mobilen Detached-Modus zeigt die App
      // englische Defaults ("Search"-Button + "Cancel"). Diese Labels liegen NICHT
      // in der translations-Tabelle, sondern in den autocomplete()-Optionen.
      a.hooks.registerHook("beforeAutocompleteOptions", function (options) {
        try {
          if (options && typeof options === "object") {
            options.placeholder = "Produkte suchen";
            options.detachedCancelButtonText = "✕"; // ✕ statt "Abbrechen"
          }
          return options;
        } catch (e) { return options; }
      });

      // Treffer-Zähler nativ rendern (gezielter Hook, KEIN Layout-Ersatz → kein
      // Mount-Risiko): kompakt "X Ergebnisse" statt "1 – 12 von X … in 0.0s".
      // Klasse ais-Stats-text beibehalten, damit bestehendes CSS greift.
      a.hooks.registerHook("beforeInstantSearchStatsTemplate", function (_def, data, html) {
        try {
          var n = data && (data.nbHits != null ? data.nbHits : data.nbSortedHits);
          if (n == null) return _def;
          return html`<span class="ais-Stats-text">${Number(n).toLocaleString("de-DE")} Ergebnisse</span>`;
        } catch (e) { return _def; }
      });

      // Autocomplete-Kollektionen: generisches Grid-Icon → echtes Vorschaubild der
      // Kollektion (Feld `image` im Kollektions-Index). Fällt bei Fehler auf das
      // App-Default zurück (try/catch → _def), kann das Dropdown also nicht brechen.
      // Autocomplete-Produkte: Verfügbarkeits-Status ergänzen — das Standard-
      // Template zeigt keinen „Ausverkauft"-Hinweis. Bei abweichender Signatur
      // oder Fehler → _def (Dropdown kann nicht brechen).
      a.hooks.registerHook("beforeAutocompleteProductTemplate", function (_def, params) {
        try {
          var p = params || {};
          if (!p.item || !p.html) return _def;
          return renderAcProduct(p);
        } catch (e) { return _def; }
      });

      a.hooks.registerHook("beforeAutocompleteCollectionsTemplate", function (_def, params) {
        try {
          var item = params.item, html = params.html, components = params.components;
          var img = collImg(item && item.image);
          var url = "/collections/" + ((item && item.handle) || "");
          var title;
          try { title = components.Highlight({ hit: item, attribute: "title" }); } catch (e) { title = (item && item.title) || ""; }
          return html`
            <a class="aa-ItemLink rd-acoll" href=${url}>
              <div class="aa-ItemContent">
                <div class="aa-ItemIcon aa-ItemIcon--noBorder rd-acoll__pic" style=${img ? { backgroundImage: "url('" + img + "')" } : null}></div>
                <div class="aa-ItemContentBody">
                  <div class="aa-ItemContentTitle">${title}</div>
                </div>
              </div>
            </a>`;
        } catch (e) { return _def; }
      });
    } catch (e) {}
  }

  // Documented entry point: register when the app announces its hooks are ready.
  document.addEventListener("algolia.hooks.initialize", register);
  // Safety net if the event fired before this (deferred) script attached.
  if (window.algoliaShopify && window.algoliaShopify.hooks) register();

  /* Header-Suche: Enter führte zu ALLEN Artikeln statt zum Suchergebnis.
     Ursache: Algolia ersetzt im Redesign-Header das ursprüngliche
     <input name="q"> durch sein eigenes .aa-Input OHNE name-Attribut. Beim
     Submit (Enter / Lupe) navigiert die App auf die Ergebnisseite, der
     getippte Begriff geht dabei aber verloren → /search ohne q → alle Treffer.
     Fix: Submit des Header-Formulars abfangen, den getippten Wert direkt aus
     .aa-Input lesen und gezielt auf /search?q=… leiten. Capture-Phase, damit
     wir vor dem App-Handler greifen. No-op ohne Algolia (.aa-Input fehlt →
     natives name="q"-Formular bleibt) und bei leerer Eingabe. */
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form || !form.closest) return;
    var rd = form.closest("form.rd-search");
    if (!rd) return;                         // nicht die Header-Suche
    var aa = rd.querySelector(".aa-Input");
    if (!aa) return;                         // kein Algolia → natives q-Formular
    var q = (aa.value || "").trim();
    if (!q) return;                          // leere Suche → normal lassen
    e.preventDefault();
    e.stopPropagation();
    window.location.assign("/search?q=" + encodeURIComponent(q));
  }, true);

  // Quick-add from the rd-tile cards: /cart/add.js + open the theme cart drawer.
  document.addEventListener("click", function (e) {
    var btn = e.target && e.target.closest ? e.target.closest(".rd-qa-search") : null;
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    var vid = btn.getAttribute("data-vid");
    if (!vid || btn.getAttribute("aria-busy") === "true") return;
    btn.setAttribute("aria-busy", "true");
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] })
    })
      .then(function (r) { return r.ok; })
      .then(function (ok) {
        if (ok) {
          document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh"));
          document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:open"));
        }
      })
      .catch(function () {})
      .then(function () { btn.removeAttribute("aria-busy"); });
  });

  /* Filter-Drawer (Step 2): Öffnen übernimmt der App-eigene .ais-facets-button
     (toggelt .ais-facets__shown). Wir ergänzen nur Overlay + Schließen bei Klick
     außerhalb / Esc / Overlay. Nur Desktop (>=821px) — mobil bleibt App-Logik. */
  function rdDesktop() { return window.innerWidth >= 821; }
  function rdFacets() { return document.querySelector(".ais-facets"); }
  function rdDrawerOpen() { var f = rdFacets(); return !!(f && f.classList.contains("ais-facets__shown")); }
  function rdCloseDrawer() { var f = rdFacets(); if (f) f.classList.remove("ais-facets__shown"); rdSyncOverlay(); }
  function rdSyncOverlay() {
    // Filter-Toggle eindeutschen: App setzt im offenen Zustand hartkodiert
    // "Hide filters" (kein Translations-Key). Label-Text normalisieren (alle
    // Viewports); das ::before-Icon bleibt (CSS-Pseudo, nicht im textContent).
    var b = document.querySelector(".ais-facets-button");
    if (b) { var want = rdDrawerOpen() ? "Filter ausblenden" : "Filtern"; if (b.textContent !== want) b.textContent = want; }
    var ov = document.getElementById("rd-facets-overlay");
    if (rdDrawerOpen() && rdDesktop()) {
      if (!ov) {
        ov = document.createElement("div");
        ov.id = "rd-facets-overlay"; ov.className = "rd-facets-overlay";
        ov.addEventListener("click", rdCloseDrawer);
        document.body.appendChild(ov);
      }
    } else if (ov) { ov.parentNode.removeChild(ov); }
  }
  document.addEventListener("click", function (e) {
    if (!rdDesktop()) return;
    var btn = e.target && e.target.closest ? e.target.closest(".ais-facets-button") : null;
    if (btn) { setTimeout(rdSyncOverlay, 0); return; }           // App toggelt → Overlay nachziehen
    if (rdDrawerOpen()) { var f = rdFacets(); if (f && !f.contains(e.target)) rdCloseDrawer(); }
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && rdDrawerOpen()) rdCloseDrawer(); });

  /* Schnellauswahl-Chips (aus dem Such-Entwurf): eine Pill-Leiste über dem Grid,
     gespeist aus dem ART-Facet (product_type). Pragmatisch: ein Chip-Klick klickt
     das passende Sidebar-Label durch → nutzt Algolias eigene Verfeinerung, ganz
     ohne Helper-Zugriff. No-op, wenn kein ART-Facet da ist. */
  function rdFindArtList() {
    var facets = document.querySelector(".ais-facets");
    if (!facets) return null;
    var heads = facets.querySelectorAll(".ais-header, [class*='header']");
    var head = null;
    for (var i = 0; i < heads.length; i++) {
      var t = (heads[i].textContent || "").trim().toLowerCase();
      if (t === "art" || t === "product_type" || t === "type") { head = heads[i]; break; }
    }
    if (!head) return null;
    var all = facets.getElementsByTagName("*"), seen = false;
    for (var j = 0; j < all.length; j++) {
      if (all[j] === head) { seen = true; continue; }
      if (seen && all[j].classList && all[j].classList.contains("ais-RefinementList")) return all[j];
    }
    return null;
  }

  function rdReadArt(rl, max) {
    var out = [];
    if (!rl) return out;
    var items = rl.querySelectorAll(".ais-RefinementList-item");
    for (var i = 0; i < items.length && out.length < max; i++) {
      var li = items[i], label = li.querySelector(".ais-RefinementList-label");
      if (!label) continue;
      var countEl = label.querySelector(".ais-RefinementList-count");
      var count = countEl ? countEl.textContent.trim() : "";
      var name = (label.textContent || "");
      if (count) name = name.replace(count, "");
      name = name.replace(/\s+/g, " ").trim();
      if (!name) continue;
      out.push({ name: name, count: count, label: label, selected: (li.className || "").indexOf("selected") > -1 });
    }
    return out;
  }

  var rdRailSig = "";
  function rdSyncChips() {
    var hitsBox = document.querySelector(".ais-hits-container") || document.querySelector(".ais-Hits");
    if (!hitsBox || !hitsBox.parentNode) return;
    var rl = rdFindArtList();
    // Max. 10 Chips. Die App kappt das product_type-Facet hart bei 10 (kein
    // „Mehr anzeigen"), d.h. mehr Kategorien gibt die Storefront nicht her —
    // eine „Weitere anzeigen"-Funktion bräuchte ein höheres Facet-Limit im
    // Algolia-Dashboard. Für „mehr filtern" gibt es bereits den „Filtern"-Drawer.
    var items = rdReadArt(rl, 10);
    var rail = document.getElementById("rd-chiprail");
    if (!items.length) { if (rail) rail.parentNode.removeChild(rail); rdRailSig = ""; return; }
    var sig = items.map(function (it) { return it.name + ":" + it.count + ":" + (it.selected ? 1 : 0); }).join("|");
    if (rail && sig === rdRailSig) return; // unverändert → kein Rebuild (verhindert Loop)
    rdRailSig = sig;
    if (!rail) {
      rail = document.createElement("div");
      rail.id = "rd-chiprail";
      rail.className = "rd-chiprail";
      hitsBox.parentNode.insertBefore(rail, hitsBox);
    }
    rail.innerHTML = "";
    var lbl = document.createElement("span");
    lbl.className = "rd-chiprail__lbl";
    lbl.textContent = "Schnellauswahl";
    rail.appendChild(lbl);
    items.forEach(function (it) {
      var chip = document.createElement("button");
      chip.type = "button";
      chip.className = "rd-chip" + (it.selected ? " is-active" : "");
      chip.setAttribute("aria-pressed", it.selected ? "true" : "false");
      var n = document.createElement("span");
      n.className = "rd-chip__name"; n.textContent = it.name; chip.appendChild(n);
      if (it.count) { var c = document.createElement("span"); c.className = "rd-chip__count"; c.textContent = it.count; chip.appendChild(c); }
      // Aktiver Chip = gesetzter Filter → „×" zeigt, dass ein Klick ihn entfernt.
      if (it.selected) { var x = document.createElement("span"); x.className = "rd-chip__x"; x.setAttribute("aria-hidden", "true"); x.textContent = "×"; chip.appendChild(x); }
      chip.addEventListener("click", function (e) { e.preventDefault(); try { it.label.click(); } catch (err) {} });
      rail.appendChild(chip);
    });
  }

  // Überschrift + In-Page-Suchfeld in eine gemeinsame Flex-Zeile holen
  // (Überschrift links, Suchfeld rechts). Einmaliges Umhängen; der contains-Guard
  // macht spätere Poll-Ticks zum No-op (kein Fokusverlust beim Tippen).
  function rdSyncSearchHead() {
    var h = document.querySelector(".ais-h2");
    var inp = document.querySelector(".ais-input");
    var fb = document.querySelector(".ais-facets-button");
    if (!h || !inp) return;
    var head = document.getElementById("rd-srchhead");
    if (head && head.contains(h) && head.contains(inp) && (!fb || head.contains(fb))) return;
    if (!head) {
      head = document.createElement("div");
      head.id = "rd-srchhead"; head.className = "rd-srchhead";
      h.parentNode.insertBefore(head, h);
    }
    head.appendChild(h);      // Überschrift links
    head.appendChild(inp);    // Suchfeld direkt daneben (links)
    if (fb) head.appendChild(fb); // „Filtern" rechtsbündig (CSS: margin-left:auto)
  }

  function rdInitChips() {
    rdSyncChips(); rdSyncOverlay(); rdSyncSearchHead();
    // InstantSearch rendert/aktualisiert asynchron (Initial-Render, Verfeinerung,
    // SPA-Query-Wechsel). Schlanker Poll als zuverlässiger Treiber: rdSyncChips ist
    // idempotent (sig-guard) → günstiger No-op. rdSyncOverlay/rdSyncSearchHead als
    // Sicherheitsnetz (guard-geschützt, kein Re-Move bei unverändertem DOM).
    setInterval(function () { rdSyncChips(); rdSyncOverlay(); rdSyncSearchHead(); }, 500);
  }

  if (document.readyState !== "loading") rdInitChips();
  else document.addEventListener("DOMContentLoaded", rdInitChips);
})();
